import Vue from 'vue'
import Router from 'vue-router'
import MobileDetect from "mobile-detect";

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: () => ({x: 0, y: 0}),
    routes: [
        {
            path: '/notfound',
            name: 'notfound',
            component: () => import(/* webpackChunkName: "notfound" */ './views/NotFound.vue')
        },
        {
            path: '/:id',
            name: 'home',
            component: () => import(/* webpackChunkName: "game" */ './views/Home.vue'),
            // beforeEnter: (to, from, next) => {

            //     const md = new MobileDetect(window.navigator.userAgent);
            //     if (!to.query.embed && !md.mobile()) {

            //         let query = "";
            //         if(to.query.validLocation === null)
            //             query = '?validLocation';
            //         else if(to.query.invalidLocation === null)
            //             query = '?invalidLocation';
            //         else if(to.query.multipleLocations === null)
            //             query = '?multipleLocations';

            //         if(to.query.language != null)
            //             if(query)
            //                 query += "&language=" + to.query.language;
            //             else
            //                 query = "?language=" + to.query.language;



            //         next('/desktop/' + to.params.id + query);
            //     } else {
            //         next();
            //     }
            // }
        },
        {
            path: '/desktop/:id',
            name: 'desktop',
            component: () => import(/* webpackChunkName: "game" */ './views/Desktop.vue')
        },
        {
            path: "*",
            component: () => import(/* webpackChunkName: "notfound" */ './views/NotFound.vue'),
            //    { path: '/search', component: SearchUser, props: (route) => ({ query: route.query.q }) }
        }

    ]
});